import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '../context/useAuth'
import { isNoSignInPreviewActive } from '../debug'
import {
  saveUserNotificationPreferences,
  subscribeToUserNotificationPreferences,
} from '../services/notificationService'
import type { UserNotificationPreferences } from '../types/schema'

export const useNotificationPreferences = () => {
  const { currentUser } = useAuth()
  const userId = currentUser?.uid ?? null
  const [preferences, setPreferences] = useState<UserNotificationPreferences | null>(null)

  useEffect(() => {
    if (!userId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- resets preferences when signed out
      setPreferences(null)
      return
    }
    if (isNoSignInPreviewActive()) {
      setPreferences(null)
      return
    }

    const unsubscribe = subscribeToUserNotificationPreferences(userId, (loaded) => {
      setPreferences(loaded)
    })

    return () => {
      unsubscribe()
    }
  }, [userId])

  const savePreferences = useCallback(
    async (next: UserNotificationPreferences) => {
      if (!userId) return
      await saveUserNotificationPreferences(userId, next)
      setPreferences(next)
    },
    [userId],
  )

  return { preferences, savePreferences }
}
